import React from "react";
import { RefreshCcw } from "lucide-react";
import { Button } from "@/components/ui/button";

export default class PublicPageErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("Public page render error:", error, info);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-slate-50 px-4 py-10">
          <div className="mx-auto max-w-lg rounded-2xl border border-red-200 bg-white p-6 shadow-sm">
            <h1 className="text-lg font-semibold text-slate-950">Не удалось открыть страницу</h1>
            <p className="mt-2 text-sm leading-relaxed text-slate-600">
              Произошла ошибка при загрузке. Попробуйте обновить страницу или откройте ссылку в Chrome
              через меню ⋮ → «Открыть в браузере».
            </p>
            <Button className="mt-4" onClick={this.handleReload}>
              <RefreshCcw className="mr-2 h-4 w-4" />
              Обновить
            </Button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
